import { render, staticRenderFns } from "./isr-porla-ganancia-enla-enajenacion-de-inmuebles.vue?vue&type=template&id=72403e09&lang=html&"
import script from "./isr-porla-ganancia-enla-enajenacion-de-inmuebles.vue?vue&type=script&lang=js&"
export * from "./isr-porla-ganancia-enla-enajenacion-de-inmuebles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports